import JSXComponent from "../../../../dist/jsx-render/JSXComponent";
import dom from "../../../../dist/jsx-render/dom";
import { IWidgetComponent } from "./IWidgetComponent";
import { WidgetLists } from "../Widgets/WidgetLists";
import { LanguageString } from "../../../Model/LanguageString";
import { app } from "../../../Frame/App";
import { ITableColumn } from "../../Table/ITableColumn";
import { TableColumnTypes } from "../../Table/TableColumnTypes";
import { TableColumnAlign } from "../../Table/TableColumnAlign";
import { MsoTable } from "../../Table/MsoTable";
import { ListItem } from "../../../Model/ListItem";
import { EditTypes } from "../../Table/EditTypes";

export type WidgetListsComponentProps = {
    widget: WidgetLists;
    title: LanguageString;
}

export class WidgetListsComponent extends JSXComponent implements IWidgetComponent {
    props: WidgetListsComponentProps;
    private table: MsoTable;
    private data: ListItem[];

    constructor(props: WidgetListsComponentProps) {
        super(props);
    }

    private Columns: ITableColumn[] = [
        { type: TableColumnTypes.Custom, dataField: "parentId", number: 1, fixedWidth: "40px" },
        { type: TableColumnTypes.String, dataField: "name", number: 2, headerText: "Name", cssClass: "title-item", align: TableColumnAlign.Left },
    ]

    public element: HTMLElement =
        <div className="widget Background-Blur-90-MSO">
            <div className="title-row">
                <div className="title mr-auto">{(this.props.title[`value${app.languageUpperCase}`] && this.props.title[`value${app.languageUpperCase}`].trim().length > 0) ? this.props.title[`value${app.languageUpperCase}`] : this.props.title[`value${app.defaultLanguageUpperCase}`]}</div>
            </div>
            <div className="content-row">
                {this.renderList()}
            </div>
        </div>;

    renderList(): HTMLElement {
        let div: HTMLElement = <div className="container overflow-auto"></div>;
        this.table = new MsoTable(div, {
            loadOnCreate: false,
            enableScroll: true,
            rowsPerPage: 100,
            fixedLayout: true,
            fixedHeader: true,
            idField: "id",
            settingsName: "measuresList",
            editType: EditTypes.None,
            rowClickCallback: (ev: MouseEvent) => {
                let row = (event.target as HTMLElement).closest(".mt-content-row");
                const id = (row as HTMLElement).getAttribute("data-id");
                $.ajax({
                        type: "POST",
                        url: app.resolveUrl("~/api/gridView/change/" + id + "/0"),
                        success: (() => {
                            location.href = app.resolveUrl("~/measures/MeasureList") ;
                        }),
                        error: ((response) => {
                            alert(response.statusText + ": " + response.responseText);
                        })
                    });
            },
            getCustomContent: (field: string, model: any): HTMLElement => {
                if (field == "parentId") {
                    let icon: HTMLElement;
                    let val = model[field];
                    switch (val) {
                        case 1:
                            icon = <i class="far fa-key mr-2"></i>
                            break;
                        case 0:
                            icon = <i class="far fa-users mr-2"></i>
                            break;
                    }
                    return icon;
                }
            }
        });
        return div;
    }

    public render(): HTMLElement {
        this.props.widget.setGridPosition();
        // load data
        $.ajax({
            url: app.resolveUrl(`~/api/widget/getMeasuresListData/${this.props.widget.props.art}/${this.props.widget.props.excludeAdministrative}`),
            type: "GET",
            dataType: 'json',
            contentType: "application/json; charset=utf-8",
            success: (reponse) => {
                this.data = reponse;
                this.table.createAll(this.Columns, this.data, null, null);
            },
            error: ((response) => {
                app.addError(response.statusText + ": " + response.responseText);
            })
        });

        return this.element;
    }
}